// src/utils/bolsasFinancierasUtils.js
// Utilidades y catálogo maestro para Bolsas Financieras, Categorías de Egresos y Clasificación Fijo/Variable

/**
 * Plantilla oficial basada en el documento "26.08.05 DIARIO DE BANCO CORTO" de Agave Azul V.
 * Define las 6 Bolsas Fundamentales, sus categorías de egresos, conceptos específicos y su fondeo de ingresos.
 */
export const PLANTILLA_EGRESOS_AGAVE_V = [
    {
        id: 'cat_servicio',
        nombre: 'Servicio',
        descripcion: 'Servicios operativos fijos del fraccionamiento (contratos recurrentes)',
        color: '#10b981', // Verde esmeralda
        conceptosIngresoAsociados: ['Cuota de Mantenimiento', 'Pago Anual Cuota Mantto'],
        conceptos: [
            { id: 'egr_cfe', nombre: 'CFE', tipoGasto: 'Fijo' },
            { id: 'egr_tel', nombre: 'TELÉFONO/INTERNET', tipoGasto: 'Fijo' },
            { id: 'egr_seg', nombre: 'SEGURO SISTEMAS', tipoGasto: 'Fijo' },
            { id: 'egr_conserje', nombre: 'CONSERJERÍA', tipoGasto: 'Fijo' },
            { id: 'egr_poda', nombre: 'PODA JARDINERÍA', tipoGasto: 'Fijo' },
            { id: 'egr_vigilancia', nombre: 'VIGILANCIA', tipoGasto: 'Fijo' },
            { id: 'egr_limp_alb', nombre: 'LIMPIEZA DE ALBERCA', tipoGasto: 'Fijo' },
            { id: 'egr_admo', nombre: 'ADMO EXT 19 / INT 17-18', tipoGasto: 'Fijo' },
            { id: 'egr_contable', nombre: 'CONTABLE / NOTARIO', tipoGasto: 'Fijo' }
        ]
    },
    {
        id: 'cat_insumo',
        nombre: 'Insumo',
        descripcion: 'Insumos y consumibles operativos variables para áreas comunes',
        color: '#3b82f6', // Azul
        conceptosIngresoAsociados: ['Cuota de Mantenimiento', 'Pago Anual Cuota Mantto'],
        conceptos: [
            { id: 'egr_agua_alb', nombre: 'AGUA ALBERCA', tipoGasto: 'Variable' },
            { id: 'egr_alb', nombre: 'ALBERCA', tipoGasto: 'Variable' },
            { id: 'egr_limpieza', nombre: 'LIMPIEZA', tipoGasto: 'Variable' },
            { id: 'egr_jardineria', nombre: 'JARDINERÍA', tipoGasto: 'Variable' },
            { id: 'egr_varios', nombre: 'VARIOS', tipoGasto: 'Variable' },
            { id: 'egr_festejos', nombre: 'FESTEJOS Y ASAMBLEAS', tipoGasto: 'Variable' }
        ]
    },
    {
        id: 'cat_comision',
        nombre: 'Comisión',
        descripcion: 'Comisiones bancarias, fiscales y de plataformas',
        color: '#6366f1', // Índigo
        conceptosIngresoAsociados: ['Cuota de Mantenimiento', 'Pago Anual Cuota Mantto'],
        conceptos: [
            { id: 'egr_bancaria', nombre: 'BANCARIA', tipoGasto: 'Fijo' },
            { id: 'egr_hacienda', nombre: 'HACIENDA', tipoGasto: 'Variable' }
        ]
    },
    {
        id: 'cat_proyecto',
        nombre: 'Proyecto (Reserva y Mejoras)',
        descripcion: 'Fondo de proyectos correctivos, preventivos y obras extraordinarias',
        color: '#8b5cf6', // Morado
        conceptosIngresoAsociados: ['Adeudos anteriores', 'Recargos o intereses', 'Cuota Extraordinaria', 'Otros'],
        conceptos: [
            { id: 'egr_correctivo', nombre: 'CORRECTIVO', tipoGasto: 'Variable' },
            { id: 'egr_preventivo', nombre: 'PREVENTIVO', tipoGasto: 'Variable' },
            { id: 'egr_especifico', nombre: 'ESPECÍFICO', tipoGasto: 'Variable' },
            { id: 'egr_adq_equipos', nombre: 'ADQUISICIÓN DE EQUIPOS Y HERRAMIENTAS', tipoGasto: 'Variable' }
        ]
    },
    {
        id: 'cat_proy_alberca',
        nombre: 'Proyecto Alberca',
        descripcion: 'Fondo específico para obras e instalaciones de alberca',
        color: '#f59e0b', // Ámbar
        conceptosIngresoAsociados: ['Cuota Extraordinaria'],
        conceptos: [
            { id: 'egr_calefaccion', nombre: 'CALEFACCIÓN', tipoGasto: 'Variable' },
            { id: 'egr_veneciano', nombre: 'VENECIANO', tipoGasto: 'Variable' },
            { id: 'egr_civil', nombre: 'CIVIL', tipoGasto: 'Variable' }
        ]
    },
    {
        id: 'cat_tags',
        nombre: 'Tag / Control Vehicular',
        descripcion: 'Fondo para compra de tags/llaveros RFID y mantenimiento de portones',
        color: '#14b8a6', // Teal
        conceptosIngresoAsociados: ['Venta de tags RFID', 'Control vehicular', 'Entrada tag', 'TAG'],
        conceptos: [
            { id: 'egr_adq_tags', nombre: 'ADQUISICIÓN', tipoGasto: 'Variable' },
            { id: 'egr_porton', nombre: 'PORTÓN', tipoGasto: 'Variable' }
        ]
    },
    {
        id: 'cat_palapa',
        nombre: 'Renta Palapa / Amenidades',
        descripcion: 'Fondo recaudado por renta de amenidades y sus mejoras',
        color: '#ea580c', // Naranja
        conceptosIngresoAsociados: ['Renta Palapa', 'Amenidades', 'Servicios', 'APARTADO DE PALAPA'],
        conceptos: [
            { id: 'egr_palapa_proy', nombre: 'PROYECTO', tipoGasto: 'Variable' },
            { id: 'egr_palapa_corr', nombre: 'CORRECTIVO', tipoGasto: 'Variable' }
        ]
    },
    {
        id: 'cat_traslado',
        nombre: 'Traslado',
        descripcion: 'Movimientos puente, traslados entre cuentas y reembolsos',
        color: '#64748b', // Pizarra
        conceptosIngresoAsociados: ['Traslado', 'Otros'],
        conceptos: [
            { id: 'egr_traslado', nombre: 'TRASLADO', tipoGasto: 'Variable' }
        ]
    }
];

/**
 * Normaliza y devuelve las categorías de egreso almacenadas, o genera una estructura compatible
 * a partir de la lista plana existente.
 */
export const normalizarCategoriasEgreso = (storedCategorias = null, flatListFallback = []) => {
    if (Array.isArray(storedCategorias) && storedCategorias.length > 0) {
        return storedCategorias.map((cat, idx) => ({
            id: cat.id || `cat_${idx}_${Date.now()}`,
            nombre: String(cat.nombre || 'Sin nombre').trim(),
            descripcion: cat.descripcion || '',
            color: cat.color || '#6366f1',
            esBolsaProyecto: Boolean(cat.esBolsaProyecto),
            cuotaExtraAsociadaId: cat.cuotaExtraAsociadaId || null,
            montoCuotaExtra: cat.montoCuotaExtra != null ? Number(cat.montoCuotaExtra) : null,
            frecuenciaCuotaExtra: cat.frecuenciaCuotaExtra || 'monthly',
            mesInicioCuotaExtra: cat.mesInicioCuotaExtra !== undefined ? Number(cat.mesInicioCuotaExtra) : 1,
            duracionMesesCuotaExtra: cat.duracionMesesCuotaExtra != null ? Number(cat.duracionMesesCuotaExtra) : 6,
            congelacion: {
                habilitada: Boolean(cat.congelacion?.habilitada),
                periodicidad: cat.congelacion?.periodicidad || 'mensual',
                saldoCongeladoAcumulado: Number(cat.congelacion?.saldoCongeladoAcumulado || 0),
                historico: Array.isArray(cat.congelacion?.historico) ? cat.congelacion.historico : []
            },
            conceptosIngresoAsociados: Array.isArray(cat.conceptosIngresoAsociados) ? cat.conceptosIngresoAsociados : ['Cuota de Mantenimiento'],
            conceptos: Array.isArray(cat.conceptos)
                ? cat.conceptos.map((c, cIdx) => (
                    typeof c === 'string'
                        ? { id: `c_${cIdx}_${Date.now()}`, nombre: c.trim(), tipoGasto: 'Variable' }
                        : { id: c.id || `c_${cIdx}_${Date.now()}`, nombre: String(c.nombre || '').trim(), tipoGasto: c.tipoGasto === 'Fijo' ? 'Fijo' : 'Variable' }
                ))
                : []
        }));
    }

    // Si no existen categorías pero hay una lista plana, empaquetar en una categoría inicial
    if (Array.isArray(flatListFallback) && flatListFallback.length > 0) {
        return [{
            id: 'cat_general',
            nombre: 'General',
            descripcion: 'Categoría principal de egresos',
            color: '#10b981',
            conceptosIngresoAsociados: ['Cuota de Mantenimiento', 'Pago Anual Cuota Mantto'],
            conceptos: flatListFallback.filter(Boolean).map((nombre, i) => ({
                id: `egr_auto_${i}`,
                nombre: String(nombre).trim(),
                tipoGasto: 'Variable'
            }))
        }];
    }

    // Si no hay nada, retornar la plantilla oficial de Agave V
    return PLANTILLA_EGRESOS_AGAVE_V;
};

/**
 * Aplana todos los conceptos específicos de egreso para mantener compatibilidad con conceptosEgresoList
 */
export const obtenerTodosConceptosEgreso = (categorias = []) => {
    const list = [];
    const seen = new Set();

    (categorias || []).forEach(cat => {
        (cat.conceptos || []).forEach(c => {
            const nombre = typeof c === 'string' ? c.trim() : String(c.nombre || '').trim();
            if (nombre && !seen.has(nombre.toLowerCase())) {
                seen.add(nombre.toLowerCase());
                list.push(nombre);
            }
        });
    });

    return list;
};

/**
 * Busca si un concepto de egreso es por defecto Fijo o Variable según la configuración de categorías
 */
export const determinarTipoGastoPorDefecto = (categoriaNombre, conceptoNombre, categorias = []) => {
    if (!categoriaNombre || !categorias.length) return 'Variable';
    const cat = categorias.find(c => c.nombre?.toLowerCase() === categoriaNombre.toLowerCase() || c.id === categoriaNombre);
    if (!cat) return 'Variable';

    if (conceptoNombre) {
        const conc = (cat.conceptos || []).find(c => {
            const nom = typeof c === 'string' ? c : c.nombre;
            return nom?.toLowerCase() === conceptoNombre.toLowerCase();
        });
        if (conc && typeof conc === 'object' && conc.tipoGasto) {
            return conc.tipoGasto;
        }
    }

    // Heurística si la categoría es Servicio o Comisión
    if (cat.nombre?.toLowerCase().includes('servicio') || cat.nombre?.toLowerCase().includes('fijo')) {
        return 'Fijo';
    }

    return 'Variable';
};

/**
 * Extrae la descripción limpia de una cuota extraordinaria a partir de cualquier campo del pago o ingreso,
 * removiendo prefijos redundantes ("Cuota Extra:", "Cuota Extraordinaria:").
 */
export const extraerDescCuotaExtra = (p = {}, ing = {}) => {
    let raw = p?.cuotaExtraDesc || p?.cuotaExtraordinaria || ing?.cuotaExtraDesc || ing?.cuotaExtraordinaria || '';
    if (!raw && p?.detalle && String(p.detalle).toLowerCase().includes('extra')) {
        raw = p.detalle;
    }
    if (!raw && p?.concepto && String(p.concepto).toLowerCase().includes('extra') && String(p.concepto).includes('·')) {
        raw = p.concepto.split('·').slice(1).join(' ');
    }
    if (!raw && ing?.concepto && String(ing.concepto).toLowerCase().includes('extra') && String(ing.concepto).includes('·')) {
        raw = ing.concepto.split('·').slice(1).join(' ');
    }
    if (!raw && p?.observaciones && String(p.observaciones).toLowerCase().includes('cuota extraordinaria:')) {
        const match = String(p.observaciones).match(/cuota extraordinaria:\s*([^($\n]+)/i);
        if (match) raw = match[1];
    }
    if (!raw && ing?.observaciones && String(ing.observaciones).toLowerCase().includes('cuota extraordinaria:')) {
        const match = String(ing.observaciones).match(/cuota extraordinaria:\s*([^($\n]+)/i);
        if (match) raw = match[1];
    }

    return String(raw || '')
        .replace(/cuota\s*extraordinaria\s*:?/gi, '')
        .replace(/cuota\s*extra\s*:?/gi, '')
        .replace(/\(\s*parcial\s*\)/gi, '')
        .replace(/\(\s*parc\.?\s*\)/gi, '')
        .trim();
};

/**
 * Determina si una partida de ingreso coincide con un concepto buscado,
 * inspeccionando no solo el concepto principal sino también la cuota extraordinaria, detalle y observaciones.
 */
export const partidaCoincideConConcepto = (partida, conceptoBuscado) => {
    if (!partida || !conceptoBuscado) return false;
    const buscadoNorm = String(conceptoBuscado).trim().toLowerCase();
    if (!buscadoNorm) return false;

    const conceptoNorm = String(partida.concepto || '').trim().toLowerCase();
    if (conceptoNorm && (conceptoNorm === buscadoNorm || conceptoNorm.includes(buscadoNorm) || buscadoNorm.includes(conceptoNorm))) {
        return true;
    }

    const extraDescNorm = String(partida.cuotaExtraDesc || '').trim().toLowerCase();
    if (extraDescNorm && (extraDescNorm === buscadoNorm || extraDescNorm.includes(buscadoNorm) || buscadoNorm.includes(extraDescNorm))) {
        return true;
    }

    const detalleNorm = String(partida.detalle || '').trim().toLowerCase();
    if (detalleNorm && (detalleNorm === buscadoNorm || detalleNorm.includes(buscadoNorm))) {
        return true;
    }

    const obsNorm = String(partida.observaciones || '').trim().toLowerCase();
    if (obsNorm && (obsNorm === buscadoNorm || obsNorm.includes(buscadoNorm))) {
        return true;
    }

    const rawConcepto = String(partida.rawIngreso?.concepto || '').trim().toLowerCase();
    if (rawConcepto && (rawConcepto === buscadoNorm || rawConcepto.includes(buscadoNorm))) {
        return true;
    }

    return false;
};

/**
 * Mapea una partida de ingreso o concepto de ingreso hacia su Bolsa Financiera correspondiente
 */
export const obtenerBolsaDeIngreso = (conceptoIngreso, categorias = [], partida = null) => {
    if (!conceptoIngreso && !partida) return 'Otras Recaudaciones';
    const cLower = String(conceptoIngreso || partida?.concepto || '').trim().toLowerCase();
    const descExtra = String(partida?.cuotaExtraDesc || '').trim().toLowerCase();

    for (const cat of categorias) {
        const catNombreLower = String(cat.nombre || '').trim().toLowerCase();

        // 1. Coincidencia directa de la cuota extraordinaria con el nombre de la categoría o proyecto
        if (descExtra && (descExtra === catNombreLower || descExtra.includes(catNombreLower) || catNombreLower.includes(descExtra))) {
            return cat.nombre;
        }

        // 2. Coincidencia con conceptos de ingreso asociados
        const asociados = (cat.conceptosIngresoAsociados || []).map(a => String(a).trim().toLowerCase());
        if (asociados.some(a => {
            if (!a) return false;
            return cLower.includes(a) || a.includes(cLower) || (descExtra && (descExtra.includes(a) || a.includes(descExtra)));
        })) {
            return cat.nombre;
        }
    }

    // Fallbacks por palabras clave
    if (cLower.includes('mantenimiento') || cLower.includes('mantto')) return 'Servicio / Mantenimiento';
    if (cLower.includes('tag') || cLower.includes('rfid')) return 'Tag / Control Vehicular';
    if (cLower.includes('palapa') || cLower.includes('amenidad')) return 'Renta Palapa / Amenidades';
    if (cLower.includes('alberca')) return 'Proyecto Alberca';
    if (cLower.includes('recargo') || cLower.includes('extraordinaria') || cLower.includes('interes')) return 'Proyecto (Reserva y Mejoras)';

    return 'Otras Recaudaciones';
};

/**
 * Encuentra qué otras categorías de egreso comparten un concepto de ingreso específico.
 */
export const obtenerCategoriasQueCompartenConcepto = (conceptoIngreso, categorias = [], categoriaExcluidaId = null) => {
    if (!conceptoIngreso || !Array.isArray(categorias)) return [];
    const conceptoNorm = String(conceptoIngreso).trim().toLowerCase();

    return categorias
        .filter(cat => {
            if (categoriaExcluidaId && cat.id === categoriaExcluidaId) return false;
            const asociados = (cat.conceptosIngresoAsociados || []).map(a => String(a).trim().toLowerCase());
            return asociados.includes(conceptoNorm);
        })
        .map(cat => cat.nombre);
};

/**
 * Mapea todos los conceptos de ingreso y determina cuáles son compartidos entre múltiples categorías.
 * Retorna un mapa: { [conceptoNombre]: string[] con nombres de categorías asociadas }
 */
export const obtenerMapaConceptosCompartidos = (categorias = []) => {
    const mapa = {};
    if (!Array.isArray(categorias)) return mapa;

    categorias.forEach(cat => {
        (cat.conceptosIngresoAsociados || []).forEach(ci => {
            const norm = String(ci).trim();
            if (!mapa[norm]) mapa[norm] = [];
            if (!mapa[norm].includes(cat.nombre)) {
                mapa[norm].push(cat.nombre);
            }
        });
    });

    return mapa;
};

/**
 * Calcula los saldos disponibles de las bolsas financieras (Fondo Común Desglosado)
 * a partir de las listas de categorías, ingresos y egresos.
 * Incluye aislamiento para Bolsas de Proyecto y soporte de fondos congelados con compensación.
 */
export const calcularSaldosDeBolsas = (categorias = [], ingresos = [], egresos = []) => {
    if (!categorias || !categorias.length) return {};

    // Aplanar partidas de ingresos (soporte para tickets multi-concepto y cuotas extraordinarias de proyecto)
    const partidasIngresos = [];
    (ingresos || []).forEach(ing => {
        if (ing.deleted || ing.metodoPago === 'registro_automatico') return;
        if (Array.isArray(ing.pagos) && ing.pagos.length > 0) {
            ing.pagos.forEach((p, idx) => {
                const monto = Number(p.montoNeto != null ? p.montoNeto : (p.monto != null ? p.monto : 0));
                const cuotaExtraDesc = extraerDescCuotaExtra(p, ing);
                partidasIngresos.push({
                    id: `${ing.id}_partida_${idx}`,
                    concepto: p.concepto || ing.concepto || '',
                    monto,
                    detalle: p.detalle || ing.detalle || '',
                    observaciones: p.observaciones || ing.observaciones || '',
                    cuotaExtraDesc,
                    cuotaExtraId: p.cuotaExtraId || ing.cuotaExtraId || null,
                    rawIngreso: ing
                });
            });
        } else {
            const monto = Number(ing.montoTotal != null ? ing.montoTotal : (ing.montoNeto != null ? ing.montoNeto : (ing.monto != null ? ing.monto : 0)));
            const cuotaExtraDesc = extraerDescCuotaExtra(ing, ing);
            partidasIngresos.push({
                id: ing.id,
                concepto: ing.concepto || '',
                monto,
                detalle: ing.detalle || '',
                observaciones: ing.observaciones || '',
                cuotaExtraDesc,
                cuotaExtraId: ing.cuotaExtraId || null,
                rawIngreso: ing
            });
        }
    });

    const egresosValidos = (egresos || []).filter(eg => !eg.deleted);

    // Identificar bolsas de proyecto para aislamiento de fondeo
    const bolsasProyecto = categorias.filter(c => Boolean(c.esBolsaProyecto));

    // Paso 1: Análisis individual por categoría
    const analisisInicial = categorias.map((cat, idx) => {
        const catNombreNorm = (cat.nombre || '').toLowerCase().trim();
        const conceptosIngreso = cat.conceptosIngresoAsociados || [];
        const conceptosEspecificos = (cat.conceptos || []).map(c => {
            const nom = typeof c === 'string' ? c : c.nombre;
            return (nom || '').toLowerCase().trim();
        });

        const conceptosExclusivos = [];
        const conceptosCompartidos = [];
        const hermanasSet = new Set();

        // Para bolsas de proyecto, el fondeo es exclusivo de ese proyecto
        if (cat.esBolsaProyecto) {
            conceptosExclusivos.push(cat.nombre);
            if (cat.cuotaExtraAsociadaId) conceptosExclusivos.push(cat.cuotaExtraAsociadaId);
        } else {
            conceptosIngreso.forEach(ci => {
                const hermanas = obtenerCategoriasQueCompartenConcepto(ci, categorias, cat.id);
                if (hermanas.length > 0) {
                    conceptosCompartidos.push(ci);
                    hermanas.forEach(h => hermanasSet.add(h));
                } else {
                    conceptosExclusivos.push(ci);
                }
            });
        }

        const categoriasVinculadas = Array.from(hermanasSet);
        const esBolsaMadreCompartida = !cat.esBolsaProyecto && conceptosCompartidos.length > 0;

        let totalIngresosExclusivos = 0;
        let totalFondoCompartido = 0;

        partidasIngresos.forEach(partida => {
            const partConceptoNorm = (partida.concepto || '').toLowerCase().trim();
            const partDescNorm = (partida.cuotaExtraDesc || '').toLowerCase().trim();
            const partId = String(partida.cuotaExtraId || '');

            if (cat.esBolsaProyecto) {
                // Bolsa de Proyecto: Absorbe ingresos específicos de este proyecto
                const coincideProyecto =
                    (cat.cuotaExtraAsociadaId && partId === String(cat.cuotaExtraAsociadaId)) ||
                    (partDescNorm && (partDescNorm === catNombreNorm || catNombreNorm.includes(partDescNorm) || partDescNorm.includes(catNombreNorm))) ||
                    partConceptoNorm.includes(catNombreNorm) ||
                    (partida.detalle && String(partida.detalle).toLowerCase().includes(catNombreNorm)) ||
                    (partida.observaciones && String(partida.observaciones).toLowerCase().includes(catNombreNorm));

                if (coincideProyecto) {
                    totalIngresosExclusivos += partida.monto;
                }
            } else {
                // Bolsa regular: Verificar si la partida pertenece a una bolsa de proyecto para NO absorberla indebidamente
                const perteneceAOtroProyecto = bolsasProyecto.some(bp => {
                    const bpNombreNorm = (bp.nombre || '').toLowerCase().trim();
                    const bpId = String(bp.cuotaExtraAsociadaId || '');
                    return (bpId && partId === bpId) ||
                        (partDescNorm && (partDescNorm === bpNombreNorm || bpNombreNorm.includes(partDescNorm) || partDescNorm.includes(bpNombreNorm))) ||
                        (bpNombreNorm && partConceptoNorm.includes(bpNombreNorm));
                });

                if (!perteneceAOtroProyecto) {
                    // Si la partida de cuota extraordinaria coincide con el nombre de esta categoría regular
                    const coincideNombreCatConCuota = partDescNorm && (partDescNorm === catNombreNorm || catNombreNorm.includes(partDescNorm) || partDescNorm.includes(catNombreNorm));

                    if (coincideNombreCatConCuota || conceptosExclusivos.some(ce => partidaCoincideConConcepto(partida, ce))) {
                        totalIngresosExclusivos += partida.monto;
                    } else if (conceptosCompartidos.some(cc => partidaCoincideConConcepto(partida, cc))) {
                        totalFondoCompartido += partida.monto;
                    }
                }
            }
        });

        // Filtrar egresos asignados a esta categoría
        const egresosBolsa = egresosValidos.filter(eg => {
            const egCat = (eg.categoria || eg.categoriaEgreso || '').toLowerCase().trim();
            const egConc = (eg.concepto || eg.descripcion || '').toLowerCase().trim();
            if (egCat === catNombreNorm || egCat.includes(catNombreNorm) || catNombreNorm.includes(egCat)) return true;
            if (conceptosEspecificos.length > 0 && conceptosEspecificos.some(ce => egConc.includes(ce) || egCat.includes(ce))) return true;
            return false;
        });

        // Calcular compensaciones desde / hacia fondos congelados
        let totalEgresosBrutos = 0;
        let totalCompensadoRecibido = 0;
        let totalCompensadoDonado = 0;

        egresosBolsa.forEach(eg => {
            const m = Number(eg.montoNeto || eg.monto || 0);
            totalEgresosBrutos += m;
            if (eg.compensacionBolsaCongelada?.activa) {
                const montoComp = Number(eg.compensacionBolsaCongelada.montoCompensado || 0);
                totalCompensadoRecibido += montoComp;
            }
        });

        // Egresos donde esta bolsa fue la DONANTE de fondos congelados
        egresosValidos.forEach(eg => {
            if (eg.compensacionBolsaCongelada?.activa) {
                const donanteNombre = (eg.compensacionBolsaCongelada.bolsaDonanteNombre || eg.compensacionBolsaCongelada.bolsaDonante || '').toLowerCase().trim();
                const donanteId = eg.compensacionBolsaCongelada.bolsaDonanteId;
                if ((donanteId && donanteId === cat.id) || (donanteNombre && donanteNombre === catNombreNorm)) {
                    totalCompensadoDonado += Number(eg.compensacionBolsaCongelada.montoCompensado || 0);
                }
            }
        });

        // Egresos efectivos operativos (descontando la compensación que fue cubierta por fondos congelados)
        const totalEgresosOperativos = Math.max(0, totalEgresosBrutos - totalCompensadoRecibido);
        const excesoGastoSobreExclusivo = Math.max(0, totalEgresosOperativos - totalIngresosExclusivos);

        // Saldo congelado disponible
        const saldoCongeladoBase = Number(cat.congelacion?.saldoCongeladoAcumulado || 0);
        const saldoCongeladoDisponible = Math.max(0, saldoCongeladoBase - totalCompensadoDonado);

        return {
            id: cat.id || `bolsa_${idx}`,
            nombre: cat.nombre,
            color: cat.color || '#6366f1',
            esBolsaProyecto: Boolean(cat.esBolsaProyecto),
            congelacion: cat.congelacion,
            esBolsaMadreCompartida,
            categoriasVinculadas,
            totalIngresosExclusivos,
            totalFondoCompartido,
            totalCapacidadBolsa: totalIngresosExclusivos + totalFondoCompartido,
            totalEgresos: totalEgresosBrutos,
            totalEgresosOperativos,
            totalCompensadoRecibido,
            totalCompensadoDonado,
            saldoCongeladoDisponible,
            excesoGastoSobreExclusivo
        };
    });

    // Paso 2: Conciliación de saldos disponibles
    const mapaSaldos = {};

    analisisInicial.forEach(bolsa => {
        let totalGastadoPorHermanas = 0;
        if (bolsa.esBolsaMadreCompartida) {
            bolsa.categoriasVinculadas.forEach(nombreHermana => {
                const hermana = analisisInicial.find(b => b.nombre === nombreHermana);
                if (hermana) {
                    totalGastadoPorHermanas += hermana.excesoGastoSobreExclusivo;
                }
            });
        }

        const consumoHermanasDeFondoComun = Math.min(totalGastadoPorHermanas, bolsa.totalFondoCompartido);
        const fondoCompartidoRemanente = Math.max(
            0,
            bolsa.totalFondoCompartido - consumoHermanasDeFondoComun - bolsa.excesoGastoSobreExclusivo
        );
        const fondoExclusivoRemanente = Math.max(0, bolsa.totalIngresosExclusivos - bolsa.totalEgresosOperativos);

        let saldoDisponible = 0;
        if (bolsa.excesoGastoSobreExclusivo > 0) {
            const disponibleEnComunParaBolsa = Math.max(0, bolsa.totalFondoCompartido - consumoHermanasDeFondoComun);
            saldoDisponible = disponibleEnComunParaBolsa - bolsa.excesoGastoSobreExclusivo;
        } else {
            saldoDisponible = fondoExclusivoRemanente + fondoCompartidoRemanente;
        }

        const saldoCongelado = bolsa.saldoCongeladoDisponible || 0;

        mapaSaldos[bolsa.nombre] = {
            saldoDisponible: Math.round(saldoDisponible * 100) / 100,
            saldoCongelado: Math.round(saldoCongelado * 100) / 100,
            saldoTotal: Math.round((saldoDisponible + saldoCongelado) * 100) / 100,
            totalCapacidad: Math.round(bolsa.totalCapacidadBolsa * 100) / 100,
            totalEgresos: Math.round(bolsa.totalEgresos * 100) / 100,
            color: bolsa.color,
            esBolsaMadreCompartida: bolsa.esBolsaMadreCompartida,
            categoriasVinculadas: bolsa.categoriasVinculadas,
            esBolsaProyecto: bolsa.esBolsaProyecto,
            congelacionHabilitada: Boolean(bolsa.congelacion?.habilitada),
            periodicidadCongelacion: bolsa.congelacion?.periodicidad || 'mensual'
        };
    });

    return mapaSaldos;
};

